import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../Button/index.jsx';
import Loader from '../../../Loader/index.jsx';
import Dropdown from '../../../Form/Dropdown/index.jsx';
import FormNetlify from '../../../Form/FormNetlify/index.jsx';
import Errors from '../../../Form/Errors/index.jsx';
import Step from '../../../Form/Step/index.jsx';
import Textbox from '../../../Form/Textbox/index.jsx';
import TextArea from '../../../Form/TextArea/index.jsx';

import { 
	displayErrors, 
	objectValueExistsInArray,
	encode 
} from '../../../../utils/form.js';

import styles from './style.module.scss';

const errorMessage = {
	firstName: 'Oops.. we need to know your first name',
	lastName: 'Oops.. we need to know your last name',
	email: 'Please include a valid email',
	university: 'Please include the university you attend',
	graduationYear: 'Graduation year must be in the form \"2021\"',
	message: 'Please include a longer response'
}

const graduationYearOptions = [
	{value: new Date().getFullYear()},
	{value: new Date().getFullYear() + 1},
	{value: new Date().getFullYear() + 2},
	{value: new Date().getFullYear() + 3},
	{value: new Date().getFullYear() + 4},
	{value: new Date().getFullYear() + 5}
]

class Application extends Component {
	constructor(props) { 
    super(props);
    this.state = {
			step: 0,
			formValid: false,
			isLoading: false,
			application: {
				firstName: '',
				lastName: '',
				email: '',
				university: '',
				graduationYear: '',
				message: '',
			},
      formErrors: {
        firstName: '',
        lastName: '',
        email: '',
        university: '',
        graduationYear: '',
        message: '',
			},
			validations: {
				firstNameValid: false,
				lastNameValid: false,
				emailValid: false,
				universityValid: false,
				graduationYearValid: false,
				messageValid: false,
			}
    } 
	} 

	handleNext = (keys) => {
    const invalid = keys.some((key) => { return !this.isValid(key) })

    if (this.formCompleted()) { 
      this.setState({ formValid: true }) 
      return this.submitForm()
    }

    if(!invalid) { this.nextStep() }
  }

	handlePrev = (keys) => {
    var application = {...this.state.application}
    keys.map(key => {
      application[key] = ""
    })
    this.setState({ application })
    this.resetErrors()
    this.prevStep()
	}

	isValid = (key) => {
    const { 
			firstName,
			lastName, 
      email, 
      university, 
      graduationYear, 
      message, 
    } = this.state.application

    let formErrors = this.state.formErrors
    let validations = this.state.validations
    
    let validity;
    switch(key) {
    case 'firstName':
      validity = firstName.length > 0
      validations.firstNameValid = validity
      formErrors.firstName = validity ? '':errorMessage.firstName
			break;
		case 'lastName':
      validity = lastName.length > 0
      validations.lastNameValid = validity
      formErrors.lastName = validity ? '':errorMessage.lastName
      break;
    case 'email':
      validity = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) == null 
        ? false:true;
      validations.emailValid = validity
      formErrors.email = validity ? '':errorMessage.email
      break;
    case 'university':
			validity = university.length > 0
			validations.universityValid = validity
			formErrors.university = validity ? '':errorMessage.university
			break;
    case 'graduationYear':
      validity = objectValueExistsInArray(graduationYearOptions, graduationYear)
      validations.graduationYearValid = validity
      formErrors.graduationYear = validity ? '':errorMessage.graduationYear
      break;
    case 'message':
      validity = message.length > 20;
      validations.messageValid = validity
      formErrors.message = validity ? '':errorMessage.message
			break;
		}

    this.setState({ formErrors: formErrors, validations})
    
    return validity;
  }

	formCompleted = () =>
		!Object.values(this.state.validations).some((val) => val == false)

	submitForm = () => {
		this.setState({ isLoading: true }, () => {
			fetch("/", {
				method: "POST",
				body: encode({
					"form-name": "campus-manager-application", 
					...this.state.application})
			})
				.then(() => {
					setTimeout(() => {
						this.setState({ isLoading: false })
						this.props.onSubmit()
					}, 1200)
				})
				.catch(error => alert(error));
		})
	}

	resetErrors = () => {
    var formErrors = {...this.state.formErrors}
    Object.keys(formErrors).map(key => {
      formErrors[key] = ""
    })
    this.setState({ formErrors })
	}
	
	prevStep = () => this.setState(({ step }) => ({ step: step - 1 }))
	
	nextStep = () => this.setState(({ step }) => ({ step: step + 1 }))

	handleTextChange = (e) => {
		const { name, value } = e.target
		var application = {...this.state.application}
		application[name] = value
		this.setState({application})
	}

	handleDropdownSelect = (key, value) => {
    var application = {...this.state.application}
    application[key] = value
    this.setState({application})
	}
	
	static Loading = () =>
		<div className={styles.loader}>
			<Loader secondary/>
		</div>

	render() {
		const { formErrors, step, isLoading } = this.state
		const { 
			firstName, 
			lastName, 
			university, 
			graduationYear, 
			email, 
			message 
		} = this.state.application

		return (
			<FormNetlify name="campus-manager-application">
				<input type="hidden" name="lastName" value={lastName} />
				<input type="hidden" name="graduationYear" value={graduationYear} />
				{ displayErrors(formErrors) ? <Errors errors={formErrors} />:null }
				<Step display={step === 0}>
					<Button 
						onClick={() => this.nextStep()}
						children="Begin application process"
						secondary />
				</Step>
				<Step 
					display={step === 1}
					displayPrev
					displayNext={lastName != ""}
					handlePrev={() => this.handlePrev(["firstName", "lastName"])}
          handleNext={() => this.handleNext(["firstName", "lastName"])}>
					<div className={styles.buttonMargin}>
						<Textbox 
							name="firstName"
							autoComplete="given-name"
							placeholder="First name"
							value={firstName}
							handleInput={this.handleTextChange} />
					</div>
					{firstName
						?
							<div className={styles.buttonMargin}>
								<Textbox 
									name="lastName"
									autoComplete="family-name"
									placeholder="Last name"
									value={lastName}
									handleInput={this.handleTextChange} />
							</div>
						:null}
				</Step>
				<Step 
					display={step === 2}
					displayPrev
					displayNext={graduationYear != ''}
					handlePrev={() => this.handlePrev(["university", "graduationYear"])}
					handleNext={() => this.handleNext(["university", "graduationYear"])} >
					<div className={styles.buttonMargin}>
						<Textbox
							name="university"
							placeholder="University"
							value={university}
							handleInput={this.handleTextChange} />
					</div>
					{university
						?
							<div className={styles.buttonMargin}>
								<Dropdown 
									items={graduationYearOptions}
									placeholder="Graduation year"
									name="graduationYear"
									onChange={({value}) => 
										this.handleDropdownSelect("graduationYear", value)} />
							</div>
						:null}
				</Step>
				<Step
					display={step === 3}
					displayPrev
					displayNext={message != ''}
					handlePrev={() => this.handlePrev(["message"])}
					handleNext={() => this.handleNext(["message"])}>
						<TextArea 
							placeholder="How would you make money from an ice-cream stand in Central Park? (80-100 words, it helps us get to know you!)"
							handleInput={this.handleTextChange}
							value={message}
							name="message" />
				</Step>
				<Step
					display={step === 4}
					displayPrev
					displayNext={email != ''}
					nextText={isLoading ? <Application.Loading />:"Submit"}
					handlePrev={() => this.handlePrev(['email'])}
					handleNext={() => this.handleNext(['email'])}>
						<div className={styles.buttonMargin}>
							<Textbox
								name="email"
								placeholder="Email"
								value={email}
								handleInput={this.handleTextChange} />
						</div>
				</Step>
			</FormNetlify>
		)
	}
}

Application.propTypes = {
	onSubmit: PropTypes.func.isRequired
}

export default Application;